<nz-card style="margin-bottom: 10px;">
  <nz-spin [nzSpinning]="loading" style="margin-bottom: 10px;">

    <div class="query-condition-box margin-top-10 padding-bottom-10">
      <div>
        <form nz-form [formGroup]="validateForm">
          <div class="条件区">
            <!-- 第一行 -->
            <div nz-row>
              <div nz-col nzSpan="2" *ngIf="ShowSite">

                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "Site" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="20">
                    <nz-select formControlName="Site" (ngModelChange)="valuehandleChange()"
                      nzPlaceHolder="{{'ALL'|translate}}" nzAllowClear>
                      <nz-option *ngFor="let option of SiteList" [nzLabel]="option.siteName"
                        [nzValue]="option.siteName">
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="5" *ngIf="ShowSite">

                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "contracttype" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <nz-select formControlName="TypeCode" (ngModelChange)="valuehandleChange()">
                      <nz-option nzValue="" nzLabel="ALL"> </nz-option>
                      <nz-option *ngFor="let option of TypeList" nzValue="{{option.code}}/{{option.text}}"
                        nzLabel="{{option.code}}/{{option.text}}"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="4" *ngIf="ShowSite">

                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "contractname" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <input nz-input formControlName="ContractName" (ngModelChange)="valuehandleChange()" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="4" *ngIf="ShowSite">

                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "ENcontractname" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="22">
                    <input nz-input formControlName="ContractNameEn" (ngModelChange)="valuehandleChange()" />
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="4" *ngIf="ShowSite">

                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "contractversion" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="16">
                    <input nz-input formControlName="Versions" (ngModelChange)="valuehandleChange()" />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
            <!-- 第二行 -->
            <div nz-row class="row-with-spacing">
              <div nz-col nzSpan="4" *ngIf="ShowSchedule">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "Buyer" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nz-col nzSpan="22">
                    <nz-select [nzServerSearch]="true" formControlName="Buyer" (nzOnSearch)="userSearch($event)"
                      style="border-radius:6px;" nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true"
                      [nzShowSearch]="true" (ngModelChange)="valuehandleChange()">
                      <nz-option *ngFor="let o of userOptionList" [nzValue]="o.subjectId"
                        nzLabel="{{o.subjectId}}/{{o.username}}" nzCustomContent>
                        <span>{{o.subjectId}}/{{o.username}}</span>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="8" *ngIf="ShowSchedule">
                <nz-form-label nzSpan="8">
                  <div class="width-100-percent label-font">
                    {{ "VendorName" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="16">
                    <nz-select [nzServerSearch]="true" nzMode="multiple" formControlName="Vendor"
                      [nzMaxTagPlaceholder]="maxTagPlaceholder" [nzMaxTagCount]="1" (nzOnSearch)="VendorSearch($event)"
                      style="border-radius:6px;" nzPlaceHolder="{{'ALL'|translate}}" [nzAllowClear]="true"
                      [nzShowSearch]="true" (ngModelChange)="valuehandleChange()">
                      <ng-template #maxTagPlaceholder let-selectedOptions>
                        <span class="selected-labels" [title]="selectedLabels.join('\n')">+ {{
                          selectedOptions.length}}</span>
                      </ng-template>
                      <nz-option *ngFor="let o of VendorOptionList" [nzValue]="o.vendorCode" nzLabel="{{o.vendorName}}"
                        nzCustomContent>
                        <span>{{o.vendorName}}</span>
                      </nz-option>
                    </nz-select>
                    <!-- <input nz-input formControlName="Vendor" (ngModelChange)="valuehandleChange()" /> -->
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="4" *ngIf="ShowTemplate">
                <nz-form-label nzSpan="8">
                  <div class="width-100-percent label-font">{{ "UploadTime" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="22">
                  <nz-range-picker [nzFormat]="dateFormat" nzPlaceHolder='' formControlName="UploadTime"
                    (ngModelChange)="valuehandleChange()"></nz-range-picker>
                </nz-form-control>
              </div>

              <div nz-col nzSpan="4" *ngIf="ShowTemplate">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "Uploader" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nz-col nzSpan="22">
                    <nz-select [nzServerSearch]="true" formControlName="Buyer" (nzOnSearch)="userSearch($event)"
                      style="border-radius:6px;" nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true"
                      [nzShowSearch]="true" (ngModelChange)="valuehandleChange()">
                      <nz-option *ngFor="let o of userOptionList" [nzValue]="o.subjectId"
                        nzLabel="{{o.subjectId}}/{{o.username}}" nzCustomContent>
                        <span>{{o.subjectId}}/{{o.username}}</span>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col nzSpan="4" *ngIf="ShowTemplate">
                <nz-form-label>
                  <div class="width-100-percent label-font">
                    {{ "state" | translate }}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nz-col nzSpan="22">
                    <nz-select formControlName="Status" nzShowSearch nzAllowClear (ngModelChange)="valuehandleChange()">
                      <nz-option nzLabel="ALL" nzValue="">
                      </nz-option>
                      <nz-option nzLabel="Y" nzValue="Y"></nz-option>
                      <nz-option nzLabel="N" nzValue="N"></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>



              <div nz-col class="row-with-spacing-button" *ngIf="ShowTemplate">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeQuery()">
                  <span nz-icon nzType="search">
                  </span>
                  {{ "Query" | translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button" *ngIf="ShowTemplate">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeDownload()">
                  <span nz-icon nzType="export" nzTheme="outline"></span>
                  {{'Export'|translate}}
                </button>
              </div>


              <div nz-col class="row-with-spacing-button" *ngIf="ShowTemplate && ShowAdd">
                <button nz-button class="default-button" nzType="primary" (click)="onPageADD()">
                  <span nz-icon nzType="plus" nzTheme="outline"></span>{{
                  "Add" | translate}}</button>
              </div>



            </div>
            <!-- 第三行 -->


            <div nz-row class="row-with-spacing" style="height: 60px;" *ngIf="ShowSchedule">
              <div nz-col nzSpan="4" *ngIf="ShowSchedule">
                <nz-form-label nzSpan="16">
                  <div class="width-100-percent label-font">{{ "SendTime" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="22">
                  <nz-range-picker [nzFormat]="dateFormat" nzPlaceHolder='' formControlName="SendDate"
                    (ngModelChange)="valuehandleChange()"></nz-range-picker>
                </nz-form-control>
              </div>

              <div nz-col nzSpan="4" *ngIf="ShowSchedule">

                <nz-form-label>
                  <div class="width-100-percent label-font">{{ "schedule" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-item>
                  <nz-form-control nzSpan="20">
                    <nz-select formControlName="Schedule" nzAllowClear nzMode="multiple"
                      (ngModelChange)="valuehandleChange()" [nzMaxTagCount]="2"
                      [nzMaxTagPlaceholder]="maxTagPlaceholder2">
                      <ng-template #maxTagPlaceholder2 let-selectedOptions>
                        <span class="selected-labels" [title]="scheduleLabels.join('\n')">+ {{
                          selectedOptions.length}}</span>
                      </ng-template>
                      <nz-option *ngFor="let option of ScheduleOptions" [nzLabel]="option.nzLabel | translate"
                        [nzValue]="option.nzValue">
                      </nz-option>
                      <!-- <nz-option nzLabel="ALL" nzValue="ALL"></nz-option>
                      <nz-option nzLabel="{{'Sent' | translate }}" nzValue="0"></nz-option>
                      <nz-option nzLabel="{{'Uploaded' | translate }}" nzValue="1"></nz-option>
                      <nz-option nzLabel="{{'Approved1' | translate }}" nzValue="2"></nz-option>
                      <nz-option nzLabel="{{'Reject1' | translate }}" nzValue="3"></nz-option>
                      <nz-option nzLabel="{{'NotApproved' | translate }}" nzValue="4"></nz-option>
                      <nz-option nzLabel="{{'Terminate' | translate }}" nzValue="5"></nz-option>
                      <nz-option nzLabel="{{'Finish' | translate }}" nzValue="6"></nz-option>
                      <nz-option nzLabel="{{'NotMaintained' | translate }}" nzValue="7"></nz-option>
                      <nz-option nzLabel="{{'Maintained' | translate }}" nzValue="8"></nz-option> -->
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>


              <div nz-col class="row-with-spacing-button" *ngIf="ShowSchedule">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeQuery()">
                  <span nz-icon nzType="search">
                  </span>
                  {{ "Query" | translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button" *ngIf="ShowSchedule">
                <button nz-button nzType="primary" class="default-button" (click)="onPageChangeDownload()">
                  <span nz-icon nzType="download" nzTheme="outline"></span>
                  {{'Export'|translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button">
                <button *ngIf="ShowSchedule&&isAllowRetransmission" nz-button nzType="primary" class="default-button"
                  (click)="AgainSend()">
                  <span nz-icon nzType="send" nzTheme="outline"></span>
                  {{'retransmission'|translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button">
                <button *ngIf="ShowSchedule&&isAllowUrgeContractApproval" nz-button nzType="primary"
                  class="default-button" (click)="UrgeContractApproval()">
                  <span nz-icon nzType="exclamation" nzTheme="outline"></span>
                  {{'UrgeContractApproval'|translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button">
                <button *ngIf="ShowSchedule&&isAllowApprove" nz-button nzType="primary" class="default-button"
                  (click)="Approve()">
                  <span nz-icon nzType="check" nzTheme="outline"></span>
                  {{'Approve'|translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button">
                <button *ngIf="ShowSchedule&&isAllowReject" nz-button nzType="primary" class="default-button"
                  (click)="RejectButton()">
                  <span nz-icon nzType="close" nzTheme="outline"></span>
                  {{'RejectButton'|translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button">
                <button *ngIf="ShowSchedule&&isAllowTermination" nz-button nzType="primary" class="default-button"
                  (click)="ShowTermination()">
                  <span nz-icon nzType="stop" nzTheme="outline"></span>
                  {{'Termination'|translate}}
                </button>
              </div>

              <div nz-col class="row-with-spacing-button">
                <button *ngIf="ShowSchedule&&isAllowVendorReject" nz-button nzType="primary" class="default-button"
                  (click)="VendorReject()">
                  <span nz-icon nzType="close" nzTheme="outline"></span>
                  {{'VendorReject'|translate}}
                </button>
              </div>




            </div>

          </div>
        </form>

      </div>


    </div>
  </nz-spin>
</nz-card>